// @flow
import React, { type Node } from 'react';
import path from 'ramda/es/path';
import cn from 'classnames/bind';

import { Table, Tr, Td } from 'app/common/ui-components/table';
import type { MonthMarks } from 'app/dataTypes/MonthMarks.types';
import type { Discipline } from 'app/dataTypes/Discipline.types';
import type { Mark } from 'app/dataTypes/Mark.types';

import MarkList from '../../MarkList';
import styles from './TableDays.scss';


const cx = cn.bind(styles);

type Props = {
  className?: string,
  disciplines: Array<Discipline>,
  monthMarks: MonthMarks,
  days: Array<[number, boolean]>,
  onMouseEnterCell: (e: SyntheticMouseEvent<HTMLElement>) => void,
  onMouseLeaveCell: (e: SyntheticMouseEvent<HTMLElement>) => void,
  onMouseEnterRow: (e: SyntheticMouseEvent<HTMLElement>) => void,
  onMouseLeaveRow: (e: SyntheticMouseEvent<HTMLElement>) => void,
  loading?: boolean,
}

const TableDays = ({
  className,
  disciplines,
  monthMarks,
  days,
  onMouseEnterCell,
  onMouseLeaveCell,
  onMouseEnterRow,
  onMouseLeaveRow,
  loading,
}: Props): Node => {
  return (
    <Table className={cx(styles.root, { loading }, className)}>
      <tbody>
        {disciplines.map(({ id }, rowIndex) => (
          <Tr
            key={id}
            className={cn(styles.row, `hover_h_${rowIndex}`)}
            onMouseEnter={onMouseEnterRow}
            onMouseLeave={onMouseLeaveRow}
          >
            {days.map(([day], colIndex) => {
              const marks: Array<Mark> | void = path([id, day], monthMarks);

              return (
                <Td
                  key={day}
                  className={cn(styles.td, `hover_v_${colIndex}`)}
                  onMouseEnter={onMouseEnterCell}
                  onMouseLeave={onMouseLeaveCell}
                  stripPadding
                >
                  {marks
                    ? <MarkList
                      marks={marks}
                      className={styles.marks}
                      overflowClassName={styles.marksOverflowed}
                    />
                    : null}
                </Td>
              );
            })}
          </Tr>
        ))}
      </tbody>
    </Table>
  );
};

export default TableDays;
